export const SearchNameOrId = {
    "name": "searchNameOrId",
    "filter": [() => {
        return (items,searchText) => {
            var filtered = [];
            angular.forEach(items, function (item) {
                const itemConcnated = item.id + ' - ' + item.name ;
                if (itemConcnated.toLowerCase().includes(searchText.toLowerCase())) {
                    filtered.push(item);
                }
            });
            return filtered;
        }
    }]
};



// WEBPACK FOOTER //
// ./src/app/common/pipes/searchNameOrId.js